<template>
  <div class="d-flex align-items-center justify-content-center" style="min-height: 200px;">
    <div v-if="!byTreatmentType.length" class="text-center py-4 text-muted">
      <i class="fe fe-inbox" style="font-size:1.5rem; opacity:0.3;"></i>
      <p class="mt-2 mb-0 small">No data for this period.</p>
    </div>
    <apexchart v-else type="donut" :height="height" :options="chartOptions" :series="chartSeries" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: { apexchart: VueApexCharts },
  props: {
    byTreatmentType: { type: Array,            default: function () { return []; } },
    height:          { type: [Number, String], default: 280 },
  },
  computed: {
    chartOptions() {
      return {
        chart: { type: "donut", fontFamily: "inherit" },
        labels: this.byTreatmentType.map(function (d) { return d.name || "Unknown"; }),
        colors: ["#2563eb", "#059669", "#d97706"],
        legend: { position: "bottom" },
        dataLabels: { enabled: true },
        plotOptions: { pie: { donut: { size: "60%" } } },
        tooltip: { y: { formatter: function (v) { return v.toLocaleString() + " visits"; } } },
      };
    },
    chartSeries() {
      return this.byTreatmentType.map(function (d) { return Number(d.count || 0); });
    },
  },
};
</script>
